import useThemeStore from "@/Theme/store";
import { ArrowDownTrayIcon, HeartIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "@mui/material";

// Media Controls Component
const MediaControls = ({ onDownload, onFavorite, isFavorite, isProcessing, showFavorite = true }) => {
    return (
        <div className="absolute bottom-2 right-2 flex gap-2">
            <Tooltip title="Descargar" placement="top" arrow>
                <button
                    onClick={onDownload}
                    className="bg-black bg-opacity-50 p-1 rounded-md text-white"
                >
                    <ArrowDownTrayIcon className="w-5 h-5" />
                </button>
            </Tooltip>

            {showFavorite && onFavorite && (
                <Tooltip title="Agregar a favoritos" placement="top" arrow>
                    <button
                        onClick={onFavorite}
                        className={`bg-black bg-opacity-50 p-1 rounded-md ${isFavorite ? 'text-nue-blue' : 'text-white'}`}
                        disabled={isProcessing}
                    >
                        <HeartIcon className="w-5 h-5 font-bold" />
                    </button>
                </Tooltip>
            )}
        </div>
    );
};

// Loading Skeleton Component
const MediaLoadingSkeleton = ({ height = 'h-80' }) => {
    const { theme } = useThemeStore();
    return (
        <div
            className={`rounded-[14px] w-full my-2 ${height} flex justify-center items-center relative overflow-hidden ${theme === 'dark' ? 'bg-ship-grey' : 'bg-lavender'
                }`}
            style={{
                background: `linear-gradient(
            to right,
            ${theme === 'dark' ? '#333333' : '#e5e7eb'} 0%,
            ${theme === 'dark' ? '#555555' : '#ffffff'} 50%,
            ${theme === 'dark' ? '#333333' : '#e5e7eb'} 100%
          )`,
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite',
            }}
        />
    );
};

export { MediaControls, MediaLoadingSkeleton };
